
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Bind, Debounce } from 'lodash-decorators'

@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop({ type: Boolean, default: false }) visible: boolean

  // true-为大屏样式，false为小屏样式
  layout: boolean = false

  // 是否播放中
  isPlay: boolean = false
  rotationDegrees: number = 0

  get Global() {
    return this.$store.$global
  }

  get GuideStore() {
    return this.$store.$courseV2.GuideData
  }

  @Emit('close')
  onClose() {}

  @Emit('write-darty')
  writeDarty() {}

  // 添加窗口监听
  @Debounce(300)
  @Bind()
  addWindowResize() {
    if (window.innerHeight - 64 > 800) {
      this.layout = true
    } else {
      this.layout = false
    }
  }

  playMusic() {
    if (!this.isPlay) {
      ;(this.$refs['audio'] as any).play()
    } else {
      ;(this.$refs['audio'] as any).pause()
    }
    this.isPlay = !this.isPlay
  }

  onDairy() {
    // 关闭终页弹窗
    this.onClose()
    // 拉起写日记弹窗
    this.writeDarty()
  }

  mounted(): void {
    // 首次执行
    this.addWindowResize()
    // 绑定监听事件
    window.addEventListener('resize', this.addWindowResize)
  }
}
